import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/goodsList.vue'
createPage(Page)